import { queryPlatformLimitAndCount } from '@/api/prod/center';

const initialState = () => ({
  platformItemLimit: undefined,
  baseItemCount: 0,
  publishItemLimit: undefined,
  publishedTotalCount: 0,
  loaded: false,
  loading: false,
  fetchedAt: 0,
  loadingPromise: null,
  dailyPublishLimit:null,
  todayPublishedCount:null,
});

const platformQuota = {
  state: () => initialState(),
  mutations: {
    setPlatformQuota(state, payload) {
      console.log('%c [ payload ]-18', 'font-size:13px; background:pink; color:#bf2c9f;', payload)
      state.platformItemLimit = payload.platformItemLimit;
      state.baseItemCount = payload.baseItemCount;
      state.publishItemLimit = payload.publishItemLimit;
      state.publishedTotalCount = payload.publishedTotalCount;
      state.dailyPublishLimit = payload.dailyPublishLimit,
      state.todayPublishedCount = payload.todayPublishedCount,
      state.fetchedAt = payload.fetchedAt || Date.now();
    },
    setPlatformQuotaMeta(state, payload) {
      if (typeof payload.loaded === 'boolean') state.loaded = payload.loaded;
      if (typeof payload.loading === 'boolean') state.loading = payload.loading;
      if ('loadingPromise' in payload) state.loadingPromise = payload.loadingPromise;
    },
    resetPlatformQuota(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    fetchPlatformQuota({ commit, state }, payload = {}) {
      const force = !!payload.force;
      if (!force && state.loaded) return Promise.resolve({ ...state });
      if (state.loadingPromise) return state.loadingPromise;

      const promise = (async () => {
        commit('setPlatformQuotaMeta', { loading: true });
        try {
          const res = await queryPlatformLimitAndCount();
          if (res && res.result === 1) {
            const data = res.data || {};
            console.log('%c [ data ]-45', 'font-size:13px; background:pink; color:#bf2c9f;', data)
            commit('setPlatformQuota', {
              platformItemLimit: data.platformItemLimit,
              baseItemCount: typeof data.baseItemCount === 'number' ? data.baseItemCount : 0,
              publishItemLimit: data.publishItemLimit,
              publishedTotalCount: typeof data.publishedTotalCount === 'number' ? data.publishedTotalCount : 0,
              dailyPublishLimit:data.dailyPublishLimit,
              todayPublishedCount:data.todayPublishedCount || null,
              fetchedAt: Date.now(),
            });
          } else {
            commit('setPlatformQuota', {
              platformItemLimit: undefined,
              baseItemCount: 0,
              publishItemLimit: undefined,
              publishedTotalCount: 0,
              dailyPublishLimit:null,
              todayPublishedCount:null,
              fetchedAt: Date.now(),
            });
          }
        } catch (e) {
          commit('setPlatformQuota', {
            platformItemLimit: undefined,
            baseItemCount: 0,
            publishItemLimit: undefined,
            publishedTotalCount: 0,
            dailyPublishLimit:null,
            todayPublishedCount:null,
            fetchedAt: Date.now(),
          });
        } finally {
          commit('setPlatformQuotaMeta', { loaded: true, loading: false, loadingPromise: null });
        }
        return { ...state };
      })();

      commit('setPlatformQuotaMeta', { loadingPromise: promise });
      return promise;
    },
    clearPlatformQuota({ commit }) {
      commit('resetPlatformQuota');
    },
  },
  getters: {
    platformQuotaLoaded(state) {
      return state.loaded;
    },
    platformQuotaLoading(state) {
      return state.loading;
    },
    platformQuotaFetchedAt(state) {
      return state.fetchedAt;
    },
    platformItemLimit(state) {
      return state.platformItemLimit;
    },
    platformBaseItemCount(state) {
      return state.baseItemCount;
    },
    publishItemLimit(state) {
      return state.publishItemLimit;
    },
    publishedTotalCount(state) {
      return state.publishedTotalCount;
    },
    dailyPublishLimit(state) {
      return state.dailyPublishLimit;
    },
    todayPublishedCount(state) {
      return state.todayPublishedCount;
    },
    platformQuotaState(state) {
      return state;
    },
  },
};

export default platformQuota;
